/**
 * Product URL helpers for PDP and collection fallbacks.
 */

export function productGroupKey(p) {
  return String(p.subcategory || p.type || 'all').trim() || 'all';
}

export function productDetailPath(p) {
  const cat = String(p.category || '').trim();
  const id = String(p.id || '').trim();
  if (!cat || !id) return '/shop';
  return `/product/${encodeURIComponent(cat)}/${encodeURIComponent(id)}`;
}

/** Collection list URL (legacy / search fallback). */
export function shopPathForProduct(p) {
  const cat = String(p.category || '').trim();
  const g = productGroupKey(p);
  if (cat === 'rakhi') return `/shop/rakhi/${encodeURIComponent(g)}`;
  if (cat === 'lumba') return `/shop/lumba/${encodeURIComponent(g)}`;
  return `/shop/${encodeURIComponent(cat)}/${encodeURIComponent(g)}`;
}
